import { render, staticRenderFns } from "./SearchTipsList.vue?vue&type=template&id=497740ea&scoped=true&"
import script from "./SearchTipsList.vue?vue&type=script&lang=js&"
export * from "./SearchTipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497740ea",
  null
  
)

export default component.exports